import { render, staticRenderFns } from "./ButtonCloseGenerator.vue?vue&type=template&id=5264e2d5&"
import script from "./ButtonCloseGenerator.vue?vue&type=script&lang=js&"
export * from "./ButtonCloseGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports